import { render, staticRenderFns } from "./RankingBox.vue?vue&type=template&id=0c1bb0ac&scoped=true&"
import script from "./RankingBox.vue?vue&type=script&lang=js&"
export * from "./RankingBox.vue?vue&type=script&lang=js&"
import style0 from "./RankingBox.vue?vue&type=style&index=0&id=0c1bb0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1bb0ac",
  null
  
)

export default component.exports